import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { StyledSubOptionsContainer } from '../PdfExportConfigDialog.styles';
import { FirmPdfOptions } from '../PdfExportConfigDialog.types';
import { FirmSubOptionsProps } from './SubOptions.types';

export const FirmSubOptions = ({ options, onOptionsChange, showCondition }: FirmSubOptionsProps) => {
  if (!showCondition) {
    return null;
  }

  const handleOptionChange = (optionKey: keyof FirmPdfOptions) => {
    onOptionsChange({
      ...options,
      [optionKey]: !options[optionKey],
    });
  };

  return (
    <StyledSubOptionsContainer>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={options.summary}
              onChange={() => handleOptionChange('summary')}
            />
          }
          label="Summary"
        />
      </FormGroup>
    </StyledSubOptionsContainer>
  );
};
